<template>
  <div class="main_wrap">
    <div class="intro_banner_area">
      <div id="intro_banner" class="swiper-container">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <a href="/cscenter/notice_view.php?type=notice&idx=21221&pag=1" onclick="gaEventer('메인 - 배너', '공지사항')">
              <img class="pc" src="/refer/img/main_banner/15.png"/>
              <img class="mobile" src="/refer/img/main_banner/m/15.png"/>
            </a>
          </div>
          <div class="swiper-slide">
            <a href="/event/plus.php" onclick="gaEventer('메인 - 배너', '이벤트')">
              <img class="pc" src="/refer/img/main_banner/14.png"/>
              <img class="mobile" src="/refer/img/main_banner/m/14.png"/>
            </a>
          </div>
          <div class="swiper-slide">
            <a href="/cscenter/notice_view.php?type=notice&idx=7483&pag=1" onclick="gaEventer('메인 - 배너', '공지사항')">
              <img class="pc" src="/refer/img/main_banner/12.png"/>
              <img class="mobile" src="/refer/img/main_banner/m/12.png"/>
            </a>
          </div>
          <div class="swiper-slide">
            <a href="/event/attend.php" onclick="gaEventer('메인 - 배너', '출석체크')">
              <img class="pc" src="/refer/img/main_banner/10.png"/>
              <img class="mobile" src="/refer/img/main_banner/m/10.png"/>
            </a>
          </div>
          <div class="swiper-slide">
            <a href="/game/game.php?type=live" onclick="gaEventer('메인 - 배너', '라이브경기')">
              <img class="pc" src="/refer/img/main_banner/6.png"/>
              <img class="mobile" src="/refer/img/main_banner/m/6.png"/>
            </a>
          </div>
          <div class="swiper-slide">
            <a href="/cscenter/faq.php?type=user" onclick="gaEventer('메인 - 배너', '고객센터')">
              <img class="pc" src="/refer/img/main_banner/1.png"/>
              <img class="mobile" src="/refer/img/main_banner/m/1.png"/>
            </a>
          </div>
          <div class="swiper-slide">
            <a :href="`/cscenter/faq.php?type=other#${ isMobile ? 1678 : 1677 }`" onclick="gaEventer('메인 - 배너', '게임 문화 고객센터')">
              <img class="pc" src="/refer/img/main_banner/3.png"/>
              <img class="mobile" src="/refer/img/main_banner/m/3.png"/>
            </a>
          </div>
        </div>
        <div id="intro_banner_pagination" class="swiper-pagination"></div>
      </div>
    </div>

<!--    <Jackpot/>-->

    <div class="sports_area">
      <PopularMatch
        :matchData="matchData.match"
      />
      <div class="live_area">
        <h3 class="title">라이브</h3>
        <div class="live_list" @click="moveLivePage(matchData.liveTriggerGameId)" title="라이브 경기 보러가기"
             :style="{ height:[isMobile && matchData.liveTriggerGameId ? iframeHeight + 'px' : ''] }">
          <div class="loader" v-if="matchData.liveTriggerGameId && !isLiveMatchReady"></div>
          <iframe v-if="matchData.liveTriggerGameId" scrolling="no" frameborder="0"
                  :src="`https://animations.betcoapps.com/#/widget/animation?gameid=${matchData.liveTriggerGameId}&lang=kor`"></iframe>
          <div class="not_live_match" v-if="!matchData.liveTriggerGameId && isEmptyMatch">
            진행중인 라이브 경기가 없습니다.
          </div>
        </div>
      </div>
    </div>

    <div class="game_hit_area">
      <h3 class="title">실시간 적중내역</h3>
      <div class="hit_list">
        <LiveWinners :winners="matchData.winning" v-if="matchData.winning"/>
      </div>
    </div>

    <div class="shortcuts_area">
      <a class="item" href="/game/game.php?type=pre_match" onclick="gaEventer('메인 - 숏컷', '스포츠')">
        <span class="icon match"></span>
        <span class="tit">스포츠</span>
        <span class="tx">한판승부 제대로 붙어보자</span>
      </a>
      <a class="item" href="/game/game.php?type=live" onclick="gaEventer('메인 - 숏컷', '라이브')">
        <span class="icon roulette"></span>
        <span class="tit">라이브</span>
        <span class="tx">실시간 라이브 경기</span>
      </a>
      <a class="item" href="/game/game.php?type=statistics" onclick="gaEventer('메인 - 숏컷', '스포츠 분석')">
        <span class="icon statistics"></span>
        <span class="tit">스포츠 분석</span>
        <span class="tx">모든 종목의 분석정보</span>
      </a>
      <a class="item" href="/store/market.php" onclick="gaEventer('메인 - 숏컷', '마켓')">
        <span class="icon event"></span>
        <span class="tit">마켓</span>
        <span class="tx">아이템 구매시 골드 지급</span>
      </a>
      <a class="item" href="/store/charge.php" onclick="gaEventer('메인 - 숏컷', '캐시충전')">
        <span class="icon cash"></span>
        <span class="tit">캐시충전</span>
        <span class="tx">다양한 아이템을 구매하세요</span>
      </a>
      <a class="item" href="/cscenter/faq.php?type=user" onclick="gaEventer('메인 - 숏컷', '고객센터')">
        <span class="icon help"></span>
        <span class="tit">고객센터</span>
        <span class="tx">무엇을 도와드릴까요?</span>
      </a>
    </div>
  </div>

</template>

<script>
  import Jackpot from '@/components/main/jackpot'
  import PopularMatch from '@/components/main/popular-match'
  import LiveWinners from '@/components/main/live-winners'

  export default {
    name: "main-wrap",
    components: {
      Jackpot,
      LiveWinners,
      PopularMatch
    },
    data() {
      return {
        matchData: [],
        isLiveMatchReady: false,
        isEmptyMatch: false,
        isMobile: false,
        iframeHeight: 0,
      }
    },
    async created() {
      this.$eventBus.$on('validMatch', (gameId) => {
        if (this.matchData.liveTriggerGameId !== gameId) {
          this.matchData.liveTriggerGameId = false
          this.isLiveMatchReady = false;
          setTimeout(() => {
            this.matchData.liveTriggerGameId = gameId;
          }, 100)
        }
      })
      try {
        const {data} = await this.$http.get('/v1/main')
        this.matchData = data
      } catch (e) {
        console.log(e)
      }
    },
    mounted() {
      if (~navigator.userAgent.indexOf('Mobile') || ~navigator.userAgent.indexOf('Android')) {
        this.isMobile = true
      }
      window.addEventListener('message', ({data}) => {
        if (data.type === "applicationReady") {
          this.isLiveMatchReady = true
        }
      })
      this.initSwiperIntroBanner();
      this.iframeResize()

      setTimeout(() => {
        this.isEmptyMatch = true
      }, 500)
    },
    methods: {
      initSwiperIntroBanner: function () {
        this.swiper = new Swiper('#intro_banner', {
          loop: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          pagination: {
            el: '#intro_banner_pagination',
            clickable: true,
          }
        });
      },
      iframeResize() {
        this.iframeHeight = (window.innerWidth - 20) * .429 + 39
      },
      moveLivePage(gameId) {
        location.href = `/game/game.php?type=live${gameId ? `&game=${gameId}` : ''}`
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/main/main-wrap.vue